import React from 'react';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  chipCell: {
    fontSize: '12px',
    color: '#424242',
    padding: '8px',
    minWidth: '120px'
  }
});

const TableCellChip = withStyles({
  root: {
    background: '#E7E9F4',
    border: '1px solid transparent',
    borderRadius: '16px',
    fontFamily: 'OpenSans-Regular',
    fontSize: '12px',
    lineHeight: '18px',
    align: 'left',
    color: '#525252',
    height: 24
  }
})(Chip);
const CountChip = withStyles({
  root: {
    borderRadius: '16px',
    background: '#F4E9D2',
    fontFamily: 'OpenSans-Regular',
    fontSize: '12px',
    lineHeight: '18px',
    align: 'left',
    color: '#525252',
    marginLeft: '10px',
    height: 24
  }
})(Chip);
export const RecommendationChip = props => {
  let rowData = props;
  let {
    group = [],
    role = []
  } = rowData?.impactResult || {};
  let {
    policy = []
  } = rowData || {};
  let chipCount = parseInt(group.length) + parseInt(role.length);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, !policy?.rightSizedPolicy?.length > 0 && group.length != 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCellChip, {
    label: 'Remove Group'
  }), chipCount != 1 && chipCount > 0 && /*#__PURE__*/React.createElement(CountChip, {
    label: '+' + ' ' + (chipCount - 1)
  })), !policy?.rightSizedPolicy?.length > 0 && !group.length > 0 && role.length != 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCellChip, {
    label: 'Remove Role'
  }), chipCount != 1 && chipCount > 0 && /*#__PURE__*/React.createElement(CountChip, {
    label: '+' + ' ' + (chipCount - 1)
  })), policy?.rightSizedPolicy?.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCellChip, {
    label: 'Replace Permission'
  }), chipCount > 0 && /*#__PURE__*/React.createElement(CountChip, {
    label: '+' + ' ' + chipCount
  }))));
};
const RecommendationChipStyled = withStyles(styles)(RecommendationChip);
export default RecommendationChipStyled;